import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import initVideo, { destroyVideo, extractEmbedSource, dimensionsVideo, playVideo, pauseVideo, isVideoPlaying } from '../../../utils/embed';
import s from './VideoEmbed.scss';

const VideoEmbed = ({ content, attrs = {}, uid, img = null, embedWidth = null, embedHeight = null }) => {
	const videoEmbedSrc = content.url && extractEmbedSource(content.url, `${uid}`);
	const [showPaused, togglePlaying] = useState(true);
	let videoEmbedClasses = [s.videoEmbed];
	if (content.caption) videoEmbedClasses.push(s.videoEmbed__caption);
	if (attrs.className) videoEmbedClasses = [...videoEmbedClasses, ...attrs.className.map((cN) => s[`videoEmbed${cN}`])];

	let defaultAspectRatio = 0.5625;
	if (content.aspectRatio) {
		// Non standard format i.e. !== 16:9, 21:9, 4:3 etc
		const contentAspectRatio = content.aspectRatio.indexOf(' ') !== -1 ? content.aspectRatio.slice(0, content.aspectRatio.indexOf(' ')) : content.aspectRatio;
		defaultAspectRatio = contentAspectRatio.split('-').map(Number).reduce((acc, value) => (!acc ? value : (value / acc)), null);
	}
	const [aspectRatio, setAspectRatio] = useState(defaultAspectRatio);

	useEffect(() => {
		initVideo(videoEmbedSrc, uid, { autoplay: 1, loop: 1, mute: 1 });
		dimensionsVideo(videoEmbedSrc, uid).then((d) => {
			setAspectRatio(d.height / d.width);
			return true;
		}).catch(() => { /* No aspect ratio given */ });

		return () => {
			destroyVideo(videoEmbedSrc, uid);
		};
	}, [videoEmbedSrc, uid]);

	const toggleEmbedSound = (e) => {
		e.preventDefault();
		isVideoPlaying(videoEmbedSrc, uid).then((isPlaying) => {
			if (isPlaying) {
				togglePlaying(false);
				pauseVideo(videoEmbedSrc, uid);
			} else {
				togglePlaying(true);
				playVideo(videoEmbedSrc, uid);
			}
			return isPlaying;
		}).catch(() => { /* Unable to play */ });
	};

	const style = embedWidth && embedHeight ? { width: embedWidth, height: embedHeight } : { paddingBottom: `${aspectRatio * 100}%` };

	return (
		<figure className={videoEmbedClasses.join(' ')} style={style}>
			<a className={s.videoEmbed_clickListener} href="#unmute" onClick={toggleEmbedSound}>
				{
					showPaused && (
						<svg className={s.videoEmbed_clickListener_icon} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
							<g fill="none" fillRule="evenodd">
								<rect width="4" height="15" x="2" />
								<rect width="4" height="15" x="9" />
							</g>
						</svg>
					)
				}
				{
					!showPaused && (
						<svg className={s.videoEmbed_clickListener_icon} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
							<polygon fillRule="evenodd" points="8 1.5 15.5 13.5 .5 13.5" transform="rotate(90 8 7.5)" />
						</svg>
					)
				}
			</a>
			<div className={s.videoEmbed_container} id={`iframe-${videoEmbedSrc}-${uid}`}>{ img }</div>
			{ content.caption && <figcaption className={s.videoEmbed_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
		</figure>
	);
};

export default hot(module)(VideoEmbed);
